import { Product } from '@/models/Product';


export class MedicalService {
	getOffers(): Product[] {
		return [{
			asin: 'ALI_04',
			price: '2.81 - 8.57',
			rating: 4,
			reviewCount: 479,
			text: ' In stock High Efficiency Cotton Respirator Breathable Filtration Valve Mask. Ship from US, Russia, Poland, SPain, France, Italy.',
			produced: 'Powering the world',
			link: 'https://s.click.aliexpress.com/e/_d8IQnGm',
			images: [
				'https://ae01.alicdn.com/kf/H9fb6e2b3db7d4fff9944f3ece7f1ac5fg/In-stock-Pm2-5-Cotton-Respirator-Breathable-Valve-Mask-Insertable-Filter-High-Efficiency-Filtration-Breathable-1.jpg',
				'https://ae01.alicdn.com/kf/H22b79ef616a44cda85894ee9cf14b9af3.jpg',
				'https://ae01.alicdn.com/kf/H2c1e581f9e9a4daab6035a721779de01F.jpg',
				'https://ae01.alicdn.com/kf/H03b02cef53af4fb99998d988a6fe9371B.jpg',
				'https://ae01.alicdn.com/kf/H11cb13d1c595436788e4771771c3554fx/In-stock-Pm2-5-Cotton-Respirator-Breathable-Valve-Mask-Insertable-Filter-High-Efficiency-Filtration-Breathable-1.jpg'
			]
		},{
			asin: 'ALI_05',
			price: '1.82 - 7.06',
			rating: 4,
			reviewCount: 281,
			text: 'Disposable Breathable Mask Dust-Proof Anti-Fog FFP3 FFP2 FFP1 PM2.5 N95 KN95 Virus Protect. Ship from US, Russia, Poland, SPain, France, Italy.',
			produced: 'Powering the world',
			link: 'https://s.click.aliexpress.com/e/_d62GApy',
			images: [
				'https://ae01.alicdn.com/kf/H66be53f710fa40e8b1d0b1b622d3e684S/Disposable-Breathable-Mask-Dust-Proof-Anti-Fog-FFP3-FFP2-FFP1-PM2-5-N95-KN95-Virus-Protect.jpg',
				'https://ae01.alicdn.com/kf/H5bc68e881037447482ac8db44e4feafdf/Disposable-Breathable-Mask-Dust-Proof-Anti-Fog-FFP3-FFP2-FFP1-PM2-5-N95-KN95-Virus-Protect.jpg',
				'https://ae01.alicdn.com/kf/H1ce207eed59748698dc291349eda557aL/Disposable-Breathable-Mask-Dust-Proof-Anti-Fog-FFP3-FFP2-FFP1-PM2-5-N95-KN95-Virus-Protect.jpg'
			]
		},{
			asin: 'ALI_06',
			price: '2.75 - 19.96',
			rating: 4,
			reviewCount: 281,
			text: '1lot/20pcs mask filter Anti-dust FFP3/FFP2/FFP1/N95(N95=FFP2). Disposable mask. Ship from US, Russia, Poland, SPain, France, Italy, Australia.',
			produced: 'Powering the world',
			link: 'https://s.click.aliexpress.com/e/_d7tujqS',
			images: [
				'https://ae01.alicdn.com/kf/Hf5d992835fe14e98bb80dcf202b02a52h/In-stock-1pc-20pcs-mask-filter-Anti-dust-FFP3-FFP2-FFP1-N95-N95-FFP2-Disposable-mask.jpg',
				'https://ae01.alicdn.com/kf/Hc7772ededa844449b8e1ab4564cb2368l/In-stock-1pc-20pcs-mask-filter-Anti-dust-FFP3-FFP2-FFP1-N95-N95-FFP2-Disposable-mask.jpg',
				'https://ae01.alicdn.com/kf/Hdcdf21b023f04e7ca19f24ecaa4e49e8G/In-stock-1pc-20pcs-mask-filter-Anti-dust-FFP3-FFP2-FFP1-N95-N95-FFP2-Disposable-mask.jpg',
				'https://ae01.alicdn.com/kf/H49d9e44574c447af8abe87c9b1231ad1c.jpg'
			]
		},{
			asin: 'ALI_01',
			price: '4.98',
			rating: 5,
			reviewCount: 1,
			text: 'Xiaomi SmartMi PM2.5 Haze Mask Purely Anti-haze Face Mask Adjustable Ear Hanging Fashion 3D Design Light Breathing Mask',
			produced: 'Xiaomi SmartMi',
			link: 'https://s.click.aliexpress.com/e/_Bf9Pl9hi',
			images: [
				'https://ae01.alicdn.com/kf/Hccd6d30fd2614ec989abc1d5ccda4f55U/Xiaomi-SmartMi-PM2-5-Haze-Mask-Purely-Anti-haze-Face-Mask-Adjustable-Ear-Hanging-Fashion-3D.jpg',
				'https://ae01.alicdn.com/kf/H144b66261ce44c0c9b971e5d0e05e91cc/Xiaomi-SmartMi-PM2-5-Haze-Mask-Purely-Anti-haze-Face-Mask-Adjustable-Ear-Hanging-Fashion-3D.jpg',
				'https://ae01.alicdn.com/kf/Hb509d8d14dc3446584de659876550149C/Xiaomi-SmartMi-PM2-5-Haze-Mask-Purely-Anti-haze-Face-Mask-Adjustable-Ear-Hanging-Fashion-3D.jpg'
			]
		},{
			asin: 'ALI_02',
			price: '25.49',
			rating: 4.1,
			reviewCount: 9,
			text: ' Xiaomi Purely Anti-Pollution Respirator PM2.5 Filter Sport Anti Dust Air Pollution Mask Outdoor Air Breathing Purifier',
			produced: 'Xiaomi',
			link: 'https://s.click.aliexpress.com/e/_d6EICnw',
			images: [
				'https://ae01.alicdn.com/kf/H92410d4e14ae4f478639882e69b7f2cfS/Newest-Xiaomi-Purely-Anti-Pollution-Respirator-PM2-5-Filter-Sport-Anti-Dust-Air-Pollution-Mask-Outdoor.jpg',
				'https://ae01.alicdn.com/kf/Hd896f9a650654065827115ac1df85849V/Newest-Xiaomi-Purely-Anti-Pollution-Respirator-PM2-5-Filter-Sport-Anti-Dust-Air-Pollution-Mask-Outdoor.jpg',
				'https://ae01.alicdn.com/kf/H4ea7175e80c64d40b42b7aec8e81d845k/Newest-Xiaomi-Purely-Anti-Pollution-Respirator-PM2-5-Filter-Sport-Anti-Dust-Air-Pollution-Mask-Outdoor.jpg',
				'https://ae01.alicdn.com/kf/H7f3fc41c32c24fbb96b35a83285f21f8j/Newest-Xiaomi-Purely-Anti-Pollution-Respirator-PM2-5-Filter-Sport-Anti-Dust-Air-Pollution-Mask-Outdoor.jpg'
			]
		},{
			asin: 'ALI_03',
			price: '55.99',
			rating: 4.1,
			reviewCount: 9,
			text: ' Xiaomi Hootim Electric Anti-Haze PM2.5 Sterilizing Anion Mask Provides Active Air Supply Electric Face Mask From Xiaomi Youpin',
			produced: 'Xiaomi',
			link: 'https://s.click.aliexpress.com/e/_d761h7q',
			images: [
				'https://ae01.alicdn.com/kf/H9fa233c5a9f24e59a411b96557f9a50aA/Xiaomi-Hootim-Electric-Anti-Haze-PM2-5-Sterilizing-Anion-Mask-Provides-Active-Air-Supply-Electric-Face.jpg',
				'https://ae01.alicdn.com/kf/H2aada84f005649398830b99ba91a12dac/Xiaomi-Hootim-Electric-Anti-Haze-PM2-5-Sterilizing-Anion-Mask-Provides-Active-Air-Supply-Electric-Face.jpg',
				'https://ae01.alicdn.com/kf/Hf33056a6351e457f97a5902b676d35b3i/Xiaomi-Hootim-Electric-Anti-Haze-PM2-5-Sterilizing-Anion-Mask-Provides-Active-Air-Supply-Electric-Face.jpg',
				'https://ae01.alicdn.com/kf/H585d742248194896964de6e1ce55473dY/Xiaomi-Hootim-Electric-Anti-Haze-PM2-5-Sterilizing-Anion-Mask-Provides-Active-Air-Supply-Electric-Face.jpg',
				'https://ae01.alicdn.com/kf/H8fa611499ecd4b4688ac51f5f32a080bj/Xiaomi-Hootim-Electric-Anti-Haze-PM2-5-Sterilizing-Anion-Mask-Provides-Active-Air-Supply-Electric-Face.jpg'
			]
		}];
	}
}
